import axios from "axios"
import qs from "qs"
import store from "@/store/index.js"
import baseURL from "./baseUrl"
import { $deletefield } from "@/utils/allmethods.js"
import router from "../router/index"
import crypto from "crypto"
import CryptoJS from "crypto-js"
import cookie from "js-cookie"
import Message from "@/components/Message/index"
import i18n from "@/lang"
import ls from "@/utils/Ls"
import { auth } from "@/utils/sso"
// 前缀
// import Message from '@/components/Message/index.js'
// import Vue from 'vue'
const http = {}
// const tokenas = 'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJhZG1pbiIsImlhdCI6MTYwMjQ5NDUzNCwic3ViIjoic2hpX2Nob25nZnVAMTYzLmNvbSIsImlzcyI6Ind3dy5tcmMuY29tIiwiZXhwIjoxNjAyNDk1MjU0fQ.UEI4l-c6eOmSBunuaKekUnR2-yKfsspKQ1tiSM0CVZs'
// 签名秘钥
let tokennum = 0 //刷新token请求错误次数
// 菜单过滤
const getLanguageAndUrl = (arr) => {
  arr.forEach((item) => {
    if (item.menus_tree && item.menus_tree.length > 0) {
      getLanguageAndUrl(item.menus_tree)
    } else {
      store.commit("setAllMenuUrlList", {
        url: item.url,
        // title: item.language_name
        title: item.menu_name,
        function_uuid: item.function_uuid,
      })
    }
  })
}

const hmac_key = "299cb5bb4c9040a29c58304c25001d72" //签名演出密钥
// const hmac_key = 'asdsadasdadsad'
// Vue.prototype.$Message = Message.install
// let cs = new Vue()

const noString = [
  // 不对post数据进行   // qs.stringify({ "formData": JSON.stringify(config.data) }) 的接口
  "/importData/current-import-data",
  "/importData/user-import-data",
  "/importData/org-import-data",
  "/importData/international-import-data/v1",
  "/importData/postGrade-import-data/v1",
  "/api/importData/post-import-data/v1",
  "/api/importData/common-import-data/v1",
  "/api/importData/staff-correlation-import-data",
  "/api/fileManager/upload-file",
  "/api/staff-property/import/v1",
  "/api/operation_replace/import/v1",
]
// 没有权限就返回首页的白名单接口
const accsessWhiteUrl = [
  "/api/personalcenter/return-security",
  "/api/personalcenter/check-token",
  "/api/lable_internationalization/list-label-internation-web",
  "/api/lable_internationalization/list_lable",
  "/api/language/login-language",
  "/api/sso/getClientInfo/v1",
]
//不需要判断code的白名单
const codeWhiteUrl = ["/api/fileManager/get-file-content"]

var instance = axios.create({
  timeout: 10000000000000,
  baseURL,
})
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
// instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 请求头添加token
    if (config.method == "post") {
      let formData = ""
      if (!noString.some((item) => config.url.indexOf(item) > -1)) {
        formData = JSON.stringify(config.data)
      } else {
        formData = config.data.get("formData")
      }

      let value = ""
      if (JSON.stringify(formData) === "{}") {
        value = ""
      } else {
        value = crypto.createHmac("sha1", hmac_key).update(formData).digest("hex")
        // value = Encrypt(formData, hmac_key)
        // value = CryptoJS.HmacSHA1(formData, hmac_key).toString()
        config.headers.signature = value
      }
      if (!noString.some((item) => config.url.indexOf(item) > -1)) {
        config.data = qs.stringify({ formData: JSON.stringify(config.data) })
      }
    }
    if (store.state.token) {
      // if (process.env.NODE_ENV === "debug")
      config.headers["Authorization"] = store.state.token
      // else config.headers.token = store.state.token;
    }

    if (config.url.includes("/api/token/refresh/v1")) {
      // config.headers.refresh_token = cookie.get('refreshToken')
      config.headers["refresh-token"] = ls.get("refresh-token")
      config.data = qs.stringify({
        formData: JSON.stringify({ "~table~": "x" }),
      })
      config.headers.signature = null
      ++tokennum
    }
    config.headers["system-language-code"] = store.state.lang
    config.headers["system-client-type"] = "Web"
    config.headers["system-client-version"] = "1.0.0"

    // config.headers['system_language_code'] = store.state.lang
    // config.headers['system_client_type'] = 'web'
    // config.headers['system_client_version'] = 'v1'
    // map.put("language", "mslc1112");
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
  async (res) => {
    switch (
      res.headers["update-login-user-info"] //根据后端响应头返回数据判断是否需要更新菜单或者用户数据
    ) {
      case "upd-menu":
        try {
          const res = await http.post("/api/menu/list-user-menus/v1", {
            user_update: true,
            product_shortcode: "MMS",
          })
          if (res.code == 200) {
            let menuarr = JSON.parse(JSON.stringify(res.data))
            getLanguageAndUrl(menuarr)
            store.commit("setCurrentCopmpanyMenu", menuarr)
          } else {
            Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
            setTimeout(() => {
              router.push("/login")
            }, 2000)
          }
        } catch {
          Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
          setTimeout(() => {
            router.push("/login")
          }, 2000)
        }
        break
      case "upd-user":
        try {
          const res = await http.post("update-user-info/v1", {})
          if (res.code == 200) {
            await store.dispatch("set_userData", res.data)
          } else {
            Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
            setTimeout(() => {
              router.push("/login")
            }, 2000)
          }
        } catch {
          Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
          setTimeout(() => {
            router.push("/login")
          }, 2000)
        }
        break
      case "upd-menu-user":
        try {
          const res = await http.post("/api/menu/list-user-menus/v1", {
            user_update: true,
            product_shortcode: "MMS",
          })
          const res2 = await http.post("update-user-info/v1", {})
          if (res.code == 200) {
            let menuarr = JSON.parse(JSON.stringify(res.data))
            getLanguageAndUrl(menuarr)
            store.commit("setCurrentCopmpanyMenu", menuarr)
          } else {
            Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
            setTimeout(() => {
              router.push("/login")
            }, 2000)
            break
          }
          if (res2.code == 200) {
            await store.dispatch("set_userData", res2.data)
          } else {
            Message({ text: i18n.t(res.msg), color: "rgba(0,0,0,0.78)" })
            setTimeout(() => {
              router.push("/login")
            }, 2000)
            break
          }
        } catch {
          Message({
            text: i18n.t("message_Information_update_failed_will_log_in_again"),
            color: "rgba(0,0,0,0.78)",
          })
          setTimeout(() => {
            router.push("/login")
          }, 2000)
        }
        break
    }
    // 不提示的code
    const noTipsCode = ["01075"]
    // const isWhiteUrl = ['login', 'check-token', 'getKey', 'onload-button', '/importData/import-errorInfo-download'].some(item => res.config.url.indexOf(item) > -1)
    const isWhiteUrl = ["/importData/import-errorInfo-download"].some((item) => res.config.url.indexOf(item) > -1)
    const iscodeWhiteUrl = codeWhiteUrl.some((item) => res.config.url.indexOf(item) > -1)
    // console.log(res, 'resresres');
    if (!res.data.code) {
      if (!iscodeWhiteUrl) Message({ text: "没有响应数据以及code", color: "rgba(0,0,0,0.78)" })
      return res
    }
    if (res.data.code != 200 && !isWhiteUrl) {
      // console.log(res, 'resresres');
      // console.log(res.data, '测试refastoken');
      // 统一配置错误提示
      if (tokennum > 20) {
        //token更新次数，错误发送请求大于20则重新登录获取token  防止后端数据返回错误进行死循环
        router.push("/login")
        Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" })
        tokennum = 0
      }

      if (res.data.code == "01601" && !accsessWhiteUrl.some((item) => res.config.url.indexOf(item) > -1)) {
        //非法访问 没有权限
        setTimeout(() => {
          router.push("/dashboard")
        }, 500)
      }
      if (res.data.code == "01704") {
        const reload = async () => {
          res.config.data = JSON.parse(qs.parse(res.config.data).formData)
          let reloadRes = await http.post(res.config.url, res.config.data)
          if (Array.isArray(reloadRes.data)) {
            $deletefield(reloadRes.data)
          }
          if (typeof reloadRes.data == "object") {
            $deletefield(null, reloadRes.data)
          }
          return { data: reloadRes }
        }
        // if (process.env.NODE_ENV === "debug") {
        if (ls.get("refresh-token"))
          // 统一认证模式
          await auth.refresh().then((res) => {
            if (res) {
              reload() //重新请求
            } else {
              Message({ text: "Token refresh fail!!!", color: "rgba(0,0,0,0.78)" })
              auth.logout()
            }
          })
        else {
          //刷新token也过期了
          Message({
            text: i18n.t("message_no_token_will_log_in_again"),
            color: "rgba(0,0,0,0.78)",
          })
          auth.logout()
        }
        // } else {//普通登录模式
        //   //token过期刷新的token,继续请求刚刚的接口
        //   if (!ls.get("token")) {
        //     //没有token不发送请求
        //     // console.log(cookie.get('token'), '没用token', res);
        //     // '没有token，将重新登录'
        //     Message({
        //       text: i18n.t("message_no_token_will_log_in_again"),
        //       color: "rgba(0,0,0,0.78)",
        //     });
        //     router.push("/login");
        //   } else {
        //     let res2 = await http.post("/api/token/refresh/v1", {
        //       // token: cookie.get('token'),
        //       // refresh_token: cookie.get('refreshToken'),
        //       // 'refresh-token': cookie.get('refresh-token')
        //     });
        //     if (res2.code == 200) {
        //       if (!res2.data.token) {
        //         // '接口信息没有返回token,将重新登录'
        //         Message({
        //           text: i18n.t("message_not_return_a_token"),
        //           color: "rgba(0,0,0,0.78)",
        //         });
        //         return router.push("/login");
        //       }
        //       await store.dispatch("set_token", { token: res2.data.token });
        //       tokennum = 0;
        //       reload();//重新请求
        //     } else {
        //       Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" });
        //     }
        //   }
        // }
      } else if (res.data.code.includes("0170")) {
        Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" })
        router.push("/login")
      } else if (res.data.code.includes("01409") || res.data.code.includes("01410") || res.data.code.includes("01411")) {
        //refresh_token过期，跳转到登录页
        Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" })
        router.push("/login")
      } else {
        if (!noTipsCode.includes(res.data.code)) {
          Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" })
        }
      }
    }

    // else {
    //   if (res.data.code != 200) {
    //
    //   }
    // }
    // 删除后端传过来的多余的字段
    const whiteUrl = [
      "/api/job/getTableQuartzLogs/v1",
      "/api/ess/doc/admin/documentAll/v1",
      "/api/mailhistory/list-mailHistory/v1",
      "/api/log/list-system-log/v1",
      "/api/mailhistory/find-mailHistory/v1",
    ].some((item) => {
      return res.config.url == item
    })
    if (!whiteUrl) {
      // console.log(res.data.data);
      if (Array.isArray(res.data.data)) {
        $deletefield(res.data.data)
      }
      if (typeof res.data.data == "object") {
        $deletefield(null, res.data.data)
      }
    }
    return res
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "请求错误(400)"
          break
        case 401:
          err.message = "未授权，请重新登录(401)"
          break
        case 403:
          err.message = "拒绝访问(403)"
          break
        case 404:
          err.message = "请求出错(404)"
          break
        case 408:
          err.message = "请求超时(408)"
          break
        case 500:
          err.message = "服务器错误(500)"
          break
        case 501:
          err.message = "服务未实现(501)"
          break
        case 502:
          err.message = "网络错误(502)"
          break
        case 503:
          err.message = "服务不可用(503)"
          break
        case 504:
          err.message = "网络超时(504)"
          break
        case 505:
          err.message = "HTTP版本不受支持(505)"
          break
        default:
          err.message = `连接出错(${err.response.status})!`
      }
    } else {
      err.message = "连接服务器失败!"
    }
    Message({ text: err.message, color: "rgba(0,0,0,0.78)" })
    // router.push("/login")
    return Promise.reject(err.response)
  },
)

http.get = function (url, options) {
  // data.token = store.state.token
  // data.timestamp = new Date().valueOf()
  return new Promise((resolve, reject) => {
    instance
      .get(url, options)
      .then((response) => {
        resolve(response.data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

http.post = function (url, data, options = {}) {
  // store.state.token && (data.token = store.state.token)
  // data.system_language_code = 'mslc1112'
  // data.system_language_code = store.state.lang
  // data.system_client_type = 'web'
  // data.system_client_version = 'v1'
  // data.timestamp = new Date().valueOf()
  // const formdata = qs.stringify({ "formData": JSON.stringify(data) })
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, options)
      .then((response) => {
        resolve(response.data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

/**
 * 上传文件的请求
 * @param url
 * @returns {AxiosPromise}
 */
http.uploadFile = function (url, data, configs) {
  let config = {
    //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: url,
    //跨域请求时是否需要使用凭证
    withCredentials: true,
    // 返回数据类型
    responseType: "json", //default
    ...configs,
  }
  // console.log(configs, 'ss')
  // return instance.post(url, data, config);
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, config)
      .then((response) => {
        resolve(response.data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}
//接收文件流接口
http.uploadError = function (url, data) {
  let config = {
    //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: url,
    //跨域请求时是否需要使用凭证
    withCredentials: true,
    // 返回数据类型
    responseType: "blob", //default
  }
  // return instance.post(url, data, config);
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, config)
      .then((response) => {
        resolve(response.data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}
export default http

function Encrypt(word, key) {
  let ckey = CryptoJS.enc.Utf8.parse(key)
  // let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(word, ckey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  console.log("encrypted", encrypted.toString())
  return encrypted.toString()
}
async function refreshToken() {
  let res2 = await http.post("/api/token/refresh/v1", {
    // token: cookie.get('token'),
    // refresh_token: cookie.get('refreshToken'),
    // 'refresh-token': cookie.get('refresh-token')
  })
  if (res2.code == 200) {
    if (!res2.data.token) {
      // '接口信息没有返回token,将重新登录'
      Message({
        text: i18n.t("message_not_return_a_token"),
        color: "rgba(0,0,0,0.78)",
      })
      return router.push("/login")
    }
    await store.dispatch("set_token", { token: res2.data.token })
  } else {
    Message({ text: i18n.t(res.data.msg), color: "rgba(0,0,0,0.78)" })
  }
}

export { refreshToken }
